// Salesforce picklist values that we write to.
// Match these exactly to the API Names in SF — Setup → Object Manager
// → Opportunity → Fields & Relationships → Loss_Reason__c → picklist values.
//
// If a value is added/removed in SF, update this file too. Out-of-sync
// values cause SF writes to silently fail (or get rejected with a
// validation error).

// Loss_Reason__c picklist values, split into two groups so the UI can
// show only the relevant subset depending on whether the user is
// closing-lost (pursued, didn't win) or marking-unqualified (never
// qualified to begin with).

export const LOSS_REASONS_LOST = [
  { value: 'Lost to Competitor',          label: 'Lost to Competitor' },
  { value: 'No Decision / Non-Responsive', label: 'No Decision / Non-Responsive' },
  { value: 'Price',                       label: 'Price' },
  { value: 'Other',                       label: 'Other' },
];

export const LOSS_REASONS_UNQUALIFIED = [
  { value: 'Unqualified - Misaligned Service', label: 'Misaligned Service' },
  { value: 'Unqualified - Price',              label: 'Price' },
  { value: 'Unqualified - No Contact',         label: 'No Contact' },
];

export const ALL_LOSS_REASONS = [...LOSS_REASONS_LOST, ...LOSS_REASONS_UNQUALIFIED];
